module.exports = __webpack_public_path__ + "static/media/newsPoint03.4f3d54e9.jpeg";